import z from 'zod';

export const linkedAccountSchema = z.object({
  email: z.string().email(),
  accountId: z.string().uuid(),
  name: z.string(),
});

export type LinkedAccount = z.infer<typeof linkedAccountSchema>;
